/** @flow */

import { LOCATION_CHANGE } from "connected-react-router";

import {
  ToggleBlockApprovableChangeModal,
  ToggleDeferApprovableChangeModal,
  ToggleApproveApprovableChangeModal,
  SetApprovableChangeSchemas,
} from "@modules/service/constants/actions";

import * as approvableChangeReducers from "./reducers";
import initialState from "./state";
import type { ApprovableChangeState } from "./types";
import { cloneObject } from "@utils/object";

const resetState = () => () => initialState;

export default (
  state: ApprovableChangeState = initialState,
  action: Object,
): ApprovableChangeState => {
  const act = {
    [ToggleBlockApprovableChangeModal]: approvableChangeReducers.onToggleBlockApprovableChangeModal,
    [ToggleDeferApprovableChangeModal]: approvableChangeReducers.onToggleDeferApprovableChangeModal,
    [ToggleApproveApprovableChangeModal]:
      approvableChangeReducers.onToggleApproveApprovableChangeModal,
    [SetApprovableChangeSchemas]: approvableChangeReducers.onSetApprovableChangeSchemas,
    [LOCATION_CHANGE]: resetState,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
